<template>
    <div class="parallax-container header-container">
        <h2 class="main-title center txtAppDarkGrey">Boostez votre activité avec un site dernier cri !</h2>
        <ctabutton class="header-cta-btn"></ctabutton>
        <div class="parallax">
            <div class="overlay"></div>
            <img src="/static/build2.jpg" alt="une ville au coucher du soleil">
        </div>
    </div>
</template>

<script>
import Ctabutton from './Ctabutton'

export default {
  name: 'siteheader',
  components: {Ctabutton}
}
</script>

<style scoped>
.header-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
}
.header-cta-btn {
    margin: 0 auto;
}
.overlay {
    background: url("/static/pixel1.png") repeat scroll left top;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/Siteheader.vue